/**
 * Home page content. Everything marketing-flavoured (numbers, testimonials,
 * quick links) lives here so copy can be edited in one place.
 */

export const USPS = [
  { icon: 'badge-check', label: 'Authentic Information', sub: 'Verified & up to date' },
  { icon: 'ticket', label: 'Easy Booking', sub: 'Darshan, stay & puja' },
  { icon: 'shield-check', label: 'Trusted Services', sub: 'Vetted partners' },
  { icon: 'headset', label: '24x7 Support', sub: 'Always here for you' },
];

export const QUICK_ACCESS = [
  { icon: 'temple', label: 'Ram Mandir', sub: 'Darshan', to: '/darshan-booking' },
  { icon: 'aarti', label: 'Live Darshan', sub: '& Aarti', to: '/aarti' },
  { icon: 'diya', label: 'Puja & Seva', sub: 'Booking', to: '/epuja' },
  { icon: 'namaste', label: 'Pandit Ji', sub: 'Booking', to: '/pandits' },
  { icon: 'bed-double', label: 'Stay &', sub: 'Accommodation', to: '/hotels' },
  { icon: 'map', label: 'Travel Guide', sub: '& Itineraries', to: '/travel-guide' },
  { icon: 'utensils', label: 'Food & Prasad', sub: 'Places', to: '/services?category=Food' },
  { icon: 'heart-handshake', label: 'Seva &', sub: 'Donation', to: '/seva' },
  { icon: 'gift', label: 'Gift & Souvenir', sub: 'Store', to: '/services?category=Shopping' },
  { icon: 'languages', label: 'Multi Language', sub: 'Support', action: 'language' },
];

export const PLAN_LINKS = [
  { icon: 'route', title: 'Suggested Itineraries', sub: 'Curated 1, 2, 3 day plans', to: '/travel-guide#itineraries' },
  { icon: 'plane', title: 'How to Reach', sub: 'By Air, Train, Road', to: '/travel-guide#reach' },
  { icon: 'sunrise', title: 'Best Time to Visit', sub: 'Season, festivals & events', to: '/travel-guide#when' },
  { icon: 'info', title: 'Travel Tips', sub: 'Useful tips for a smooth journey', to: '/travel-guide#tips' },
];

export const MORE_SERVICES = [
  { icon: 'video', title: 'Live Puja', desc: 'Participate in live puja from anywhere', comingSoon: true },
  { icon: 'diya', title: 'E-Puja / Online Puja', desc: 'Perform puja online with ease', to: '/epuja' },
  { icon: 'package', title: 'Pooja Kit at Home', desc: 'Get pooja kit delivered to your home', comingSoon: true },
  { icon: 'namaste', title: 'Pandit Ji Booking', desc: 'Book experienced pandit ji for puja', to: '/pandits' },
  { icon: 'ticket', title: 'VIP Darshan', desc: 'Hassle-free darshan experience', comingSoon: true },
  { icon: 'gift', title: 'Prasad Delivery', desc: 'Get temple prasad delivered at home', comingSoon: true },
];

export const WHY_US = [
  'Trusted & Verified Services',
  'Best Price Guarantee',
  'Secure & Easy Payments',
  '24x7 Customer Support',
  'Multiple Languages Support',
  'Authentic Local Guidance',
];

// Marketing figures from the design mockup — edit here when real numbers exist.
export const NUMBERS = [
  { value: '50+', label: 'Temples' },
  { value: '100+', label: 'Puja Services' },
  { value: '500+', label: 'Verified Hotels' },
  { value: '10L+', label: 'Happy Pilgrims' },
];

// Sample content from the design mockup — replace with real reviews.
export const TESTIMONIALS = [
  { name: 'Ramesh Sharma', place: 'Jaipur, Rajasthan', rating: 5, avatar: null, text: 'The darshan booking was seamless and hassle-free. Highly recommended for every family planning a visit!' },
  { name: 'Priya Iyer', place: 'Chennai, Tamil Nadu', rating: 5, avatar: null, text: 'Loved the travel guide and hotel suggestions. Everything was perfect, from arrival to the evening aarti.' },
  { name: 'Anil Verma', place: 'Lucknow, Uttar Pradesh', rating: 5, avatar: null, text: 'Ayodhyadham.info made our trip spiritual and memorable. The timings and tips were spot on.' },
  { name: 'Meera Patel', place: 'Ahmedabad, Gujarat', rating: 4, avatar: null, text: 'Booked a puja for my parents from abroad. The pandit ji was punctual and the prasad arrived within a week.' },
];

export const FALLBACK_PLACES = [
  { title: 'Ram Mandir', subtitle: 'The grand temple of Lord Shri Ram', image: '/images/design/hero-ram-mandir.webp', to: '/temples', type: 'temple', meta: [{ icon: 'clock', text: '6:30 AM – 9:30 PM' }] },
  { title: 'Hanuman Garhi', subtitle: 'Seek blessings of Lord Hanuman', image: '/images/hanuman/temple-1.webp', to: '/temples', type: 'temple', meta: [{ icon: 'clock', text: '5:00 AM – 10:00 PM' }] },
  { title: 'Kanak Bhawan', subtitle: 'The divine palace of Mata Sita', image: '/images/kanak-bhawan/temple.jpg', to: '/temples', type: 'temple', meta: [{ icon: 'clock', text: '8:00 AM – 9:00 PM' }] },
  { title: 'Saryu Ghat', subtitle: 'Sacred ghats on the banks of River Saryu', image: '/images/ghats/saryu-ghat-1.jpeg', to: '/ghats/saryu-ghat', type: 'ghat', meta: [{ icon: 'clock', text: 'Open 24 hours' }] },
  { title: 'Ram ki Paidi', subtitle: 'Evening aarti & Deepotsav venue', image: '/images/ghats/naya-ghat-2.jpg', to: '/ghats/naya-ghat', type: 'ghat', meta: [{ icon: 'aarti', text: 'Aarti at sunset' }] },
  { title: 'Guptar Ghat', subtitle: 'Where Lord Ram took Jal Samadhi', image: '/images/ghats/guptar-ghat/1.jpg', to: '/ghats/guptar-ghat', type: 'ghat', meta: [{ icon: 'clock', text: 'Open 24 hours' }] },
];

export const TRUST_ITEMS = [
  { icon: 'shield-check', title: '100% Secure Payments', desc: 'Your transactions are safe with us' },
  { icon: 'circle-check', title: 'Instant Confirmation', desc: 'Get confirmed tickets instantly' },
  { icon: 'indian-rupee', title: 'Best Price Guarantee', desc: 'Get the best deals on bookings' },
  { icon: 'headset', title: '24x7 Customer Support', desc: 'We are here to help you anytime' },
  { icon: 'users', title: 'Trusted by Pilgrims', desc: 'Serving devotees with trust and care' },
];

export const TRAVEL_PROMO = {
  title: 'Travel Light, Travel Right',
  sub: 'Complete travel packages for a blessed journey',
  items: [
    { icon: 'bed-double', label: 'Stay' },
    { icon: 'utensils', label: 'Food' },
    { icon: 'car', label: 'Transport' },
    { icon: 'temple', label: 'Darshan' },
    { icon: 'camera', label: 'Sightseeing' },
  ],
  cta: 'Plan My Trip',
  to: '/travel-planner',
};

export const LIVE_DARSHAN = {
  title: 'Ram Lalla Live Darshan',
  sub: 'Join millions in divine moments',
  thumb: '/images/ram-lala/ram-lala-01.jpg',
};
